export default "__VITE_ASSET__BdOW2ZYS__"